// SceneForm.form.js
import * as Yup from "yup";

export const categoryOptions = [
  { key: "01", text: "CIENCIAS HUMANAS", value: "CIENCIAS HUMANAS" },
  { key: "02", text: "CIENCIAS NATURALES", value: "CIENCIAS NATURALES" },
  { key: "03", text: "HISTORIA", value: "HISTORIA" },
  { key: "04", text: "MATEMÁTICAS", value: "MATEMÁTICAS" },
  { key: "05", text: "ARTE", value: "ARTE" },
  { key: "06", text: "VIDA SALUDABLE", value: "VIDA SALUDABLE" },
  // Agrega más categorías según sea necesario
];
export const subcategoryOptions = [
  // CIENCIAS HUMANAS
  {
    key: "s01",
    text: "Antropología",
    value: "Antropología",
    category: "CIENCIAS HUMANAS",
  },
  {
    key: "s03",
    text: "Ciencias Políticas",
    value: "Ciencias Políticas",
    category: "CIENCIAS HUMANAS",
  },
  {
    key: "s05",
    text: "Filosofía",
    value: "Filosofía",
    category: "CIENCIAS HUMANAS",
  },
  {
    key: "s06",
    text: "Geografía",
    value: "Geografía",
    category: "CIENCIAS HUMANAS",
  },
  {
    key: "s07",
    text: "Gramática",
    value: "Gramática",
    category: "CIENCIAS HUMANAS",
  },
  {
    key: "s08",
    text: "Idiomas",
    value: "Idiomas",
    category: "CIENCIAS HUMANAS",
  },
  {
    key: "s09",
    text: "Psicología",
    value: "Psicología",
    category: "CIENCIAS HUMANAS",
  },
  {
    key: "s10",
    text: "Sociedad",
    value: "Sociedad",
    category: "CIENCIAS HUMANAS",
  },
  {
    key: "s44",
    text: "Educación",
    value: "Educación",
    category: "CIENCIAS HUMANAS",
  },

  // HISTORIA (Incluyo Arqueología aquí por el contexto de tus escenas)
  {
    key: "s02",
    text: "Arqueología",
    value: "Arqueología",
    category: "CIENCIAS HUMANAS",
  },
  {
    key: "s16",
    text: "Prehistoria",
    value: "Prehistoria",
    category: "HISTORIA",
  },
  {
    key: "s17",
    text: "Edad Antigua",
    value: "Edad Antigua",
    category: "HISTORIA",
  },
  { key: "s18", text: "Edad Media", value: "Edad Media", category: "HISTORIA" },
  {
    key: "s19",
    text: "Edad Moderna",
    value: "Edad Moderna",
    category: "HISTORIA",
  },
  {
    key: "s20",
    text: "Edad Contemporánea",
    value: "Edad Contemporánea",
    category: "HISTORIA",
  },

  // CIENCIAS NATURALES
  {
    key: "s11",
    text: "Astronomía",
    value: "Astronomía",
    category: "CIENCIAS NATURALES",
  },
  {
    key: "s12",
    text: "Biología",
    value: "Biología",
    category: "CIENCIAS NATURALES",
  },
  {
    key: "s13",
    text: "Botánica",
    value: "Botánica",
    category: "CIENCIAS NATURALES",
  },
  {
    key: "s14",
    text: "Geología",
    value: "Geología",
    category: "CIENCIAS NATURALES",
  },
  {
    key: "s15",
    text: "Química",
    value: "Química",
    category: "CIENCIAS NATURALES",
  },
  {
    key: "s42",
    text: "Física y Tecnología",
    value: "Física y Tecnología",
    category: "CIENCIAS NATURALES",
  } /*
  {
    key: "s43",
    text: "Tecnología de la Información y Comunicación",
    value: "Tecnología de la Información y Comunicación",
    category: "CIENCIAS NATURALES",
  },*/,

  // MATEMÁTICAS
  {
    key: "s21",
    text: "Lógica y fundamentos",
    value: "Lógica y fundamentos",
    category: "MATEMÁTICAS",
  },
  {
    key: "s22",
    text: "Aritmética",
    value: "Aritmética",
    category: "MATEMÁTICAS",
  },
  { key: "s23", text: "Álgebra", value: "Álgebra", category: "MATEMÁTICAS" },
  {
    key: "s24",
    text: "Geometría",
    value: "Geometría",
    category: "MATEMÁTICAS",
  },
  {
    key: "s25",
    text: "Matemáticas discretas",
    value: "Matemáticas discretas",
    category: "MATEMÁTICAS",
  },
  {
    key: "s26",
    text: "Matemáticas aplicadas",
    value: "Matemáticas aplicadas",
    category: "MATEMÁTICAS",
  },

  // ARTE
  { key: "s27", text: "Arquitectura", value: "Arquitectura", category: "ARTE" },
  { key: "s28", text: "Cine", value: "Cine", category: "ARTE" },
  {
    key: "s29",
    text: "Artes Escénicas",
    value: "Artes Escénicas",
    category: "ARTE",
  },
  { key: "s30", text: "Escultura", value: "Escultura", category: "ARTE" },
  { key: "s31", text: "Literatura", value: "Literatura", category: "ARTE" },
  { key: "s32", text: "Pintura", value: "Pintura", category: "ARTE" },
  {
    key: "s33",
    text: "Artes aplicadas",
    value: "Artes aplicadas",
    category: "ARTE",
  },

  // VIDA SALUDABLE
  {
    key: "s34",
    text: "Alimentación y Nutrición",
    value: "Alimentación y Nutrición",
    category: "VIDA SALUDABLE",
  },
  { key: "s35", text: "Higiene", value: "Higiene", category: "VIDA SALUDABLE" },
  {
    key: "s36",
    text: "Actividad Física y Deporte",
    value: "Actividad Física y Deporte",
    category: "VIDA SALUDABLE",
  },
  {
    key: "s37",
    text: "Bienestar, Salud Emocional y Convivencia",
    value: "Bienestar, Salud Emocional y Convivencia",
    category: "VIDA SALUDABLE",
  },
  {
    key: "s38",
    text: "Entorno Sostenible",
    value: "Entorno Sostenible",
    category: "VIDA SALUDABLE",
  },
  {
    key: "s39",
    text: "Seguridad y Prevención de Riesgos",
    value: "Seguridad y Prevención de Riesgos",
    category: "VIDA SALUDABLE",
  },
  {
    key: "s40",
    text: "Educación afectivo sexual",
    value: "Educación afectivo sexual",
    category: "VIDA SALUDABLE",
  },
  {
    key: "s41",
    text: "Prevención de dependencias",
    value: "Prevención de dependencias",
    category: "VIDA SALUDABLE",
  },
];

export function initialValuesOne(scene) {
  return {
    ModOneTitle: scene?.ModOneTitle || "",
    ModOneCategory: scene?.ModOneCategory || [],
    ModOneSubcategory: scene?.ModOneSubcategory || [],
    ModOneTags: scene?.ModOneTags || [],
    tagsInput: "",
    ModOneDescription: scene?.ModOneDescription || "",
    bannertop: scene?.bannertop || null,
    ModOneUrlsala: scene?.ModOneUrlsala || "",
  };
}

// Validation Schema
export function validationSchemaOne() {
  return Yup.object({
    ModOneTitle: Yup.string().required("El título es obligatorio"),
    ModOneCategory: Yup.array()
      .min(1, "Selecciona al menos una categoría")
      .required("La categoría es obligatoria"),
    ModOneSubcategory: Yup.array()
      .min(1, "Selecciona al menos una subcategoría")
      .required("La subcategoría es obligatoria"),
    ModOneTags: Yup.array()
      .min(1, "Ingresa al menos una etiqueta")
      .required("Las etiquetas son obligatorias"),
    ModOneDescription: Yup.string().required("La descripción es obligatoria"),
    bannertop: Yup.string().required("El banner top es obligatorio"),
    ModOneUrlsala: Yup.string()
      .url("Ingresa una URL válida")
      .required("La URL es obligatoria"),
  });
}
